import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'
import LoaderPage from 'components/ui/feedback/LoaderPage'

const DocumentsPage = lazy(() => import('pages/documents/page'))

const DocumentsRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/:jobId" element={<LoaderPage content={<DocumentsPage />} />} />
      <Route path="/" element={<LoaderPage content={<DocumentsPage />} />} />

    </Routes>
  )
}

export default DocumentsRoutes
